import AddressMode from './AddressModel';
import AutoModel from './AutoModel';
import PersonModel from'./PersonModel';
import CompanyModel from'./CompanyModel';
import ContactModel from'./ContactModel';
import DocumentModel from'./DocumentModel';
import GunModel from'./GunModel';
import ProceedingsModel from'./ProceedingsModel';
import OPMModel from'./OPMModel';
import TraitorModel from'./TraitorModel';
import BSModel from './BSModel';
import KanModel from './KanModel';

class SearchModel {
    person = new PersonModel();
    address = new AddressMode();
    auto = new AutoModel();
    company = new CompanyModel();
    contact = new ContactModel();
    document = new DocumentModel();
    gun = new GunModel();
    proceedings = new ProceedingsModel();
    opm = new OPMModel();
    traitor = new TraitorModel();
    bs = new BSModel();
    kan = new KanModel();
}

export default SearchModel